"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
const react_dom_1 = require("react-dom");
const util_1 = require("../../util");
exports.default = (0, mobx_react_1.observer)(function (props) {
    const { html, RenderingComponent } = props;
    const ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const domNode = ref.current;
        function doHydrate() {
            if (domNode && html) {
                if (domNode.innerHTML) {
                    (0, react_dom_1.unmountComponentAtNode)(domNode);
                }
                // setting outline:none fixes react "focusable" element issue. see
                // https://github.com/GMOD/jbrowse-components/issues/2160
                domNode.style.outline = 'none';
                domNode.innerHTML = html;
                // use requestIdleCallback to defer main-thread rendering
                // and hydration for when we have some free time. helps
                // keep the framerate up.
                (0, util_1.rIC)(() => {
                    (0, react_dom_1.hydrate)(react_1.default.createElement(RenderingComponent, { ...props }), domNode);
                });
            }
        }
        doHydrate();
        return () => {
            if (domNode) {
                (0, react_dom_1.unmountComponentAtNode)(domNode);
            }
        };
    }, [html, RenderingComponent, props]);
    return react_1.default.createElement("g", { ref: ref });
});
